export default __webpack_public_path__ + "static/media/fry.1cd089e9.png";